var _path, _path2, _path3, _line, _path4, _path5, _path6, _line2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line3, _path14, _line4, _path15, _path16, _path17, _line5, _line6, _line7, _line8, _circle, _circle2, _circle3, _circle4, _path18, _path19, _path20, _path21, _path22, _line9, _line10, _line11, _line12, _line13, _line14, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 520 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.769 189.325L415.355 251.315L241.332 336.536L231.769 189.325Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.373 234.643L292.893 185.162L302.68 333.946L117.968 271.755L191.369 234.645L191.373 234.643Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.687 225.528L276.797 409.344L190.654 235.21L339.687 225.528Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118.349,
    y1: 271.685,
    x2: 415.087,
    y2: 251.338,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.305 200.029L342.485 287.253L194.579 297.391L256.866 113.928L300.302 200.025L300.305 200.029Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.751 408.496L257.164 114.47",
    stroke: "white",
    strokeWidth: 0.595856
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.546 235.145L364.687 150.247L302.468 334.291L190.546 235.145Z",
    stroke: "white",
    strokeWidth: 0.595856
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 169.901,
    y1: 370.798,
    x2: 364.586,
    y2: 150.203,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.551 235.402L364.688 150.248L302.779 333.939L190.551 235.402Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.658 359.302L156.108 163.425",
    stroke: "white",
    strokeWidth: 0.595856
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.019 337.03L155.776 163.12L339.252 225.147L241.019 337.03Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M293.189 185.508L378.236 359.657L194.547 297.855L293.189 185.508Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.726 286.435L169.577 371.306L231.333 188.632L342.726 286.435Z",
    stroke: "white",
    strokeWidth: 0.595856
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M342.726 286.435L169.577 371.306L231.333 188.632L342.726 286.435Z",
    fill: "#9163BF",
    fillOpacity: 0.07,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M231.873 188.894L301.46 332.603",
    stroke: "white",
    strokeWidth: 0.595856
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 194.57,
    y1: 297.685,
    x2: 339.169,
    y2: 225.374,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.914 235.544L342.453 286.484",
    stroke: "white",
    strokeWidth: 0.595856
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 241.183,
    y1: 336.405,
    x2: 293.184,
    y2: 185.525,
    stroke: "white",
    strokeWidth: 0.595856
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.428 354.822L153.79 352.993L150.35 354.418L151.763 350.973L149.922 347.342L153.559 349.171L156.999 347.746L155.586 351.191L157.428 354.822Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.48 306.587L128.253 302.334L132.479 302.865L129.012 300.39L132.062 297.417L127.966 298.585L127.543 294.347L125.902 298.277L122.324 295.966L124.374 299.699L120.336 301.055L124.533 301.78L123.076 305.782L126.26 302.953L128.48 306.587Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.172 321.725L167.118 320.504L166.281 322.742L165.955 320.375L163.683 321.116L165.33 319.385L163.334 318.07L165.715 318.279L165.498 315.899L166.819 317.89L168.545 316.237L167.812 318.511L170.18 318.83L167.945 319.675L169.172 321.725Z",
    fill: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.148964,
    x2: 20.5968,
    y2: -0.148964,
    transform: "matrix(0.89157 0.452883 0.452883 -0.89157 99.2367 287.665)",
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.148964,
    x2: 17.398,
    y2: -0.148964,
    transform: "matrix(-0.967676 -0.252196 -0.252196 0.967676 152.407 305.169)",
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.148964,
    x2: 14.3725,
    y2: -0.148964,
    transform: "matrix(0.629686 0.77685 0.77685 -0.629686 155.936 304.917)",
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 154.406,
    y1: 346.52,
    x2: 166.943,
    y2: 319.532,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.76616,
    cy: 1.76616,
    r: 1.76616,
    transform: "matrix(0.997521 -0.0703651 -0.0703651 -0.997521 153.743 307.434)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5949,
    cy: 2.5949,
    r: 2.5949,
    transform: "matrix(0.997521 -0.0703651 -0.0703651 -0.997521 94.2086 288.959)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.83079,
    cy: 8.83079,
    r: 8.77121,
    transform: "matrix(0.997521 -0.0703651 -0.0703651 -0.997521 118.516 309.915)",
    stroke: "white",
    strokeWidth: 0.119171
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.597,
    cy: 10.597,
    r: 10.5374,
    transform: "matrix(0.997521 -0.0703651 -0.0703651 -0.997521 117.596 313.524)",
    stroke: "white",
    strokeWidth: 0.119171
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M393.787 223.842L389.927 223.916L390.684 227.702L388.219 224.731L385.731 227.683L386.518 223.903L382.658 223.799L386.104 222.057L383.779 218.975L387.289 220.583L388.249 216.843L389.181 220.59L392.703 219.009L390.355 222.074L393.787 223.842Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M374.447 194.524L372.228 197.203L372.817 200.631L370.138 198.412L366.71 199.001L368.929 196.322L368.339 192.894L371.018 195.113L374.447 194.524Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M371.306 212.367L369.948 214.124L370.398 216.299L368.64 214.941L366.466 215.391L367.824 213.634L367.374 211.459L369.131 212.817L371.306 212.367Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380.751 166.402L378.821 166.439L379.2 168.332L377.968 166.847L376.724 168.323L377.117 166.433L375.187 166.381L376.91 165.51L375.748 163.969L377.503 164.773L377.983 162.903L378.449 164.776L380.21 163.986L379.035 165.518L380.751 166.402Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M388.558 205.922L387.383 205.397L387.075 206.647L386.752 205.401L385.583 205.939L386.356 204.91L385.206 204.332L386.493 204.295L386.228 203.035L387.059 204.018L387.879 203.025L387.629 204.288L388.916 204.31L387.773 204.902L388.558 205.922Z",
    fill: "white"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 370.16,
    y1: 197.423,
    x2: 369.056,
    y2: 214.026,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 370.419,
    y1: 196.598,
    x2: 377.316,
    y2: 166.647,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 386.655,
    y1: 221.872,
    x2: 368.858,
    y2: 214.148,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 386.655,
    y1: 221.872,
    x2: 368.858,
    y2: 214.148,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 386.566,
    y1: 221.733,
    x2: 386.888,
    y2: 204.587,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 369.291,
    y1: 196.728,
    x2: 387.089,
    y2: 204.451,
    stroke: "white",
    strokeWidth: 0.297928,
    strokeDasharray: "1.19 1.19"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.809,
    cy: 196.671,
    r: 6.59898,
    transform: "rotate(63.4388 370.809 196.671)",
    stroke: "white",
    strokeWidth: 0.119171
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.494,
    cy: 322.522,
    r: 4.76296,
    transform: "rotate(-3.71677 271.494 322.522)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.889,
    cy: 265.229,
    r: 4.76296,
    transform: "rotate(-3.71677 203.889 265.229)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.657,
    cy: 257.054,
    r: 4.76296,
    transform: "rotate(-3.71677 329.657 257.054)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.195,
    cy: 229.561,
    r: 2.93105,
    transform: "rotate(-3.71677 295.195 229.561)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.134,
    cy: 290.247,
    r: 2.93105,
    transform: "rotate(-3.71677 299.134 290.247)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.448,
    cy: 294.195,
    r: 2.93105,
    transform: "rotate(-3.71677 238.448 294.195)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.497,
    cy: 233.501,
    r: 2.93105,
    transform: "rotate(-3.71677 234.497 233.501)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.418,
    cy: 198.21,
    r: 4.76296,
    transform: "rotate(-3.71677 263.418 198.21)",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M275.66 268.86L274.725 270.557C273.353 273.048 271.15 274.978 268.501 276.011C268.498 276.012 268.499 276.012 268.496 276.013C268.429 276.043 264.362 277.868 258.6 276.121C255.627 274.952 253.126 272.799 251.5 270.011C249.874 267.222 249.458 263.848 249.878 260.638C250.298 257.428 251.823 255.126 254.107 252.874C256.392 250.623 259.683 249.643 261.512 249.455C264.681 249.13 267.046 249.623 267.046 249.623L265.264 249.915C257.268 251.23 253.128 260.204 257.317 267.139C261.223 273.605 270.208 274.586 275.417 269.115L275.66 268.86Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar1);
export default __webpack_public_path__ + "static/media/heroStar1.5259ee8ba53d38bb9dea17e0a3185df2.svg";
export { ForwardRef as ReactComponent };